<div id="table_data" class="tablewrap resizetable tabpage hidden">
    <div class="table tabledata">
        <table fixedcols="[]" id="rawdatatable">
            <tr>
                <th class="datetime_column">{{'Time'|translate }}</th>
                <th class="speed_column">{{'Speed'|translate }}</th>
                <th>{{'Coordinates'|translate }}</th>
            </tr>
        </table>
    </div>
    <app-pagination [viewmode]="'print excel pages'" [printElementID]="'table_data'"></app-pagination>
</div>
